import React from 'react'
import PropTypes from 'prop-types'
import { Button, IonIcon } from 'controls'

const StepContainer = ({
  title,
  description = '',
  children = null,
  goTo,
  beforeStep,
  nextStep,
  isLastStep,
  onClose
}) => {
  const currentStep = nextStep - 1

  return (
    <div>
      <h4 style={{ marginTop: '0.3rem' }}>
        <strong>{title}</strong>
      </h4>
      <p>{description}</p>

      {children}

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          disabled={currentStep === 0}
          onClick={() => goTo(beforeStep || currentStep - 1 || 0)}
        >
          <IonIcon icon="md-arrow-back" />
        </Button>

        {isLastStep ? (
          <Button color="primary" onClick={onClose}>
            Finalizar
          </Button>
        ) : (
          <Button onClick={() => goTo(nextStep)}>
            <IonIcon icon="md-arrow-forward" />
          </Button>
        )}
      </div>
    </div>
  )
}

StepContainer.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.any,
  goTo: PropTypes.func,
  beforeStep: PropTypes.number, // Step index
  nextStep: PropTypes.number, // Step index
  isLastStep: PropTypes.bool,
  onClose: PropTypes.func
}

export default StepContainer